import { makeStyles } from '@material-ui/core/styles';
import { white, darkBlue, lightBlue, grey, anthracite, red, darkGray } from '../../Constants/Colors';
import { bodyFont } from '../../Screens/ThemeProvider';

export const useStyles = makeStyles((theme) => ({
  root: {
    background: 'rgba(216, 216, 216, 0.9)',
    opacity: '0.98',
    padding: '1rem 0 1rem 1rem',
    margin: '2rem 1.6rem',
    width: '400px',
    maxHeight: '70%',
    color: darkBlue,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
  },
  headerContainer: {
    height: 'auto',
    width: '370px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  back: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    position: 'relative',
    left: '-8px',
    cursor: 'pointer',
    '& .MuiSvgIcon-root': {
      marginRight: '0.2em',
    },
  },
  toggle: {
    cursor: 'pointer',
  },
  header: {
    '& .MuiTypography-root': {
      fontWeight: 'bold',
    },
  },
  optionsHeader: {
    paddingTop: '0.6rem',
    '& .MuiTypography-root': {
      fontWeight: 'bold',
      fontSize: '1.1rem',
      color: darkBlue,
    },
  },
  wrapper: {
    height: '95%',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    '&.closed': {
      maxHeight: 0,
    },
  },
  item: {
    marginTop: '1rem',
    cursor: 'pointer',
    '& .MuiTypography-root': {
      color: darkBlue,
      flexGrow: 1,
      fontWeight: '800',
      '&:hover': {
        color: lightBlue,
      },
      '&.selected': {
        color: lightBlue,
      },
    },
    '&:before': {
      content: '""',
      position: 'relative',
      width: '3rem',
      height: 4,
      left: 0,
      top: '0.65rem',
      backgroundColor: darkBlue,
      marginRight: '1rem',
      flexShrink: 0,
    },
    '&$disabled': {
      cursor: 'normal',
      pointerEvents: 'none',
      '& .MuiTypography-root': {
        color: darkGray,
      },
      '&:before': {
        backgroundColor: darkGray,
      },
    },
  },
  optionGroup: {
    marginTop: '1.4rem',
    '& .MuiTypography-root': {
      color: darkBlue,
      fontWeight: 700,
    },
    marginRight: '1rem',
  },
  groupTitle: {
    paddingTop: '1.4rem',
    '& .MuiTypography-root': {
      fontWeight: 600,
      fontSize: '0.97rem',
      color: darkBlue,
    },
  },
  buttonGroup: {
    width: '90%',
    //marginTop: '1rem',
    '& .MuiToggleButton-root': {
      backgroundColor: white,
      opacity: '1',
      width: '100%',
      border: '1px solid rgba(0,0,0,0.28)',
    },
    '& .MuiToggleButton-root.Mui-selected': {
      opacity: '1',
      backgroundColor: darkBlue,
      '& .MuiToggleButton-label': {
        color: white,
      },
    },
    '& .MuiToggleButton-root.Mui-disabled': {
      '& .MuiToggleButton-label': {
        color: grey,
      },
    },
    '&.MuiToggleButtonGroup-root': {
      '& .MuiToggleButton-root': {
        padding: '10px 20px',
        border: '1px solid rgba(0,0,0,0.28)',
      },

      '& .MuiToggleButton-label': {
        textTransform: 'initial',
        fontWeight: 600,
        color: darkBlue,
      },
    },
  },
  sliderContainer: {
    display: 'flex',
    marginTop: 12,
    marginRight: '1.6rem',
  },
  sliderWrapper: {
    flex: 1,
    margin: '0 24px',
  },
  select: {
    width: '90%',
    marginTop: '1rem',
    padding: '0.2rem 0.5rem 0.2rem 0.5rem',
    border: '1px solid rgba(0,0,0,0.28)',
    borderRadius: '4px',
    background: white,
    '& .MuiSelect-root': {
      background: white,
    },
    '& .MuiSelect-icon': {
      color: darkBlue,
    },
    '&.Mui-disabled': {
      '& .MuiSelect-icon': {
        color: grey,
      },
    },
  },
  componentGroupTitle1: {
    marginTop: '1.4rem',
    fontWeight: 600,
    fontSize: '1.1rem',
    color: darkBlue,
  },
  componentGroupTitle2: {
    marginTop: '1rem',
    fontStyle: 'italic',
    fontWeight: 600,
    fontSize: '0.9rem',
    color: darkBlue,
    '&.disabled': {
      color: anthracite,
    },
  },
  textArea: {
    flex: 1,
    margin: 8,
    padding: '14px',
    marginTop: '0.7rem',
    borderRadius: '4px',
    borderColor: red,
    fontSize: '1.2em',
    fontFamily: bodyFont,
    '& .MuiInputBase-root': {
      backgroundColor: white,
    },
  },
  textAreaConfiguration: {
    width: '90%',
    marginTop: '0.7rem',
    borderRadius: '4px',
    border: '1px solid rgba(0,0,0,0.28)',
    color: darkBlue,
    fontSize: '1.2em',
    padding: theme.spacing(1),
    fontFamily: bodyFont,
    '& .MuiInputBase-root': {
      backgroundColor: white,
    },
    '&:focus-visible': {
      outline: 'none',
    },
    '&::placeholder': {
      fontStyle: 'italic',
    },
  },
  textField: {
    borderRadius: '4px',
    '& .MuiInputBase-root': {
      backgroundColor: white,
      width: '8ch',
      '& input': {
        textAlign: 'center',
      },
    },
    '& .MuiInputAdornment-positionEnd': {
      marginLeft: theme.spacing(1),
      position: 'absolute',
      right: -theme.spacing(1),
      transform: 'translateX(100%)',
    },
    '& .MuiTypography-root': {
      fontWeight: 'normal',
    },
  },
  formControl: {
    margin: 0,
    display: 'flex',
    ['& .MuiOutlinedInput-notchedOutline, ' +
    '&:hover .MuiOutlinedInput-notchedOutline, ' +
    '&.Mui-focused .MuiOutlinedInput-notchedOutline']: {
      border: '1px solid rgba(0,0,0,0.28)',
    },
  },
  additionalText: {
    flex: 1,
    marginLeft: theme.spacing(1),
    lineHeight: '40px',
  },
  textFieldContainer: {
    width: '90%',
  },
  disabled: {},
}));
